import React from 'react';

const NotificationAnalyticsDashboard = () => {
  // Simplified version for testing
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Notification Analytics Dashboard</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p>Notification Analytics component is working!</p>
        <p className="text-gray-600 mt-2">This is a test version to verify the component loads properly.</p>
        <div className="mt-4 p-4 bg-blue-50 rounded">
          <p className="text-blue-800">✅ Component successfully loaded and rendered</p>
        </div>
      </div>
    </div>
  );
};

export default NotificationAnalyticsDashboard;
